import { render, staticRenderFns } from "./LayoutsCreate.vue?vue&type=template&id=09cd58ec&"
import script from "./LayoutsCreate.vue?vue&type=script&lang=js&"
export * from "./LayoutsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports